import { omit } from 'ramda'
import { createSelector } from 'reselect'

import { SharedState } from '../redux/sharedState'
import { Page } from '../utils/enums'
import { FilterEndpoint } from './filter.reducers'

const filterState = (state: SharedState) => state?.filters

const invoices = createSelector([filterState], state => state[Page.Invoices])
const orders = createSelector([filterState], state => state[Page.Orders])
const quotes = createSelector([filterState], state => state[Page.Quotes])
const products = createSelector([filterState], state => state[Page.Products])
const users = createSelector([filterState], state => state[Page.Users])

const isInitialised = createSelector(
  [filterState],
  state => state.isInitialised,
)

const isFiltersOpen = createSelector(
  [filterState],
  state => state.isFiltersOpen,
)

const byEndpoint = (endpoint: FilterEndpoint | undefined) =>
  createSelector([filterState], state =>
    state && endpoint ? state[endpoint] : undefined,
  )

const numberActiveFiltersByEndpoint = (
  endpoint: FilterEndpoint | undefined,
  omitFilters: string[] = ['page', 'sort'],
) =>
  createSelector([filterState], state =>
    state && endpoint
      ? Object.keys(omit(omitFilters, state[endpoint])).length
      : undefined,
  )

export const FilterSelector = {
  byEndpoint,
  filterState,
  invoices,
  isFiltersOpen,
  isInitialised,
  numberActiveFiltersByEndpoint,
  orders,
  products,
  quotes,
  users,
}
